"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardActions = void 0;
const _DashboardActions = require("../../modules/dashboard/actions");
require("./list");
require("./region");
require("./salesman");
require("./members");
require("./userGroups");
require("./wizard");
require("./ytj");
exports.DashboardActions = _DashboardActions.default('customer');
//# sourceMappingURL=index.js.map